export function convertToGoogleAnalyticsItem(item) {
  const gaItem = {
    item_id: item.id || "",
    item_name: item.name || "",
    item_category: item.type || "",
    price: item.price || 0,
    quantity: item.quantity || 1,
  };

  return gaItem;
}

export const isLastTokenNull = (nextTokens) => {
  const keys = Object.keys(nextTokens);
  const lastKey = keys[keys.length - 1];

  return nextTokens[lastKey] === null;
};
